import request from '@/utils/request'
import requestNoToast from '@/utils/request-no-toast'
import { INTERFACE_SPLITS } from '@/constants/module/interface'

export function getList(query) {
	return request({
		url: '/admin/v1/cars',
		method: 'get',
		params: query
	})
}
export function addCar(data) {
	return request({
		url: '/admin/v1/cars',
		method: 'post',
		data: data
	})
}
export function addCarNetInfo(id, data) {
	return request({
		url: `/admin/v1/netCars/${id}`,
		method: 'put',
		data: data
	})
}
export function addCarInsure(data) {
	return request({
		url: '/admin/v1/car_insurances',
		method: 'post',
		data: data
	})
}
export function carDetail(id, params, type = 'view') {
	return request({
		url: `${INTERFACE_SPLITS.CAR_DETAIL[type]}/${id}`,
		method: 'get',
		params
	})
}
export function getCarDetail_DCMS(params) {
	return request({
		url: '/admin/v1/dcms/manager/car/detail',
		method: 'get',
		params
	})
}
export function carUpdate(id, data) {
	return request({
		url: `/admin/v1/cars/${id}`,
		method: 'put',
		data: data
	})
}

/**
 * 更新换车信息
 * @param data
 * @returns {AxiosPromise}
 */
export function changeCarUpdate(data) {
	return request({
		url: `/admin/v1/cars/updateForChangeCar`,
		method: 'post',
		data: data
	})
}

// 申请换车验证
export function applyChangeCarCheck(data) {
	return request({
		url: '/admin/v1/tasks/ApplyCarChangeCheck',
		method: 'post',
		data: data
	})
}

// 申请换车
export function applyChangeCar(data) {
	return request({
		url: '/admin/v1/tasks/InsertApplyCarChangeRecord',
		method: 'post',
		data: data
	})
}
// 搜索车牌号
export function searchPlateNo(query) {
	return request({
		url: '/admin/v1/list_car',
		method: 'get',
		params: query
	})
}
// 获取车品牌列表/admin/v1/cars/:id
export function getBrand() {
	return request({
		url: '/admin/v1/dictionary/car/car_brand_base',
		method: 'get'
	})
}
// 获取车型列表
export function getType() {
	return request({
		url: '/admin/v1/dictionary/car/car_brand?enabled=3',
		method: 'get'
	})
}
// 获取车型列表
export function carBrand(params) {
	return request({
		url: '/admin/v1/dictionary/car/car_brand',
		method: 'get',
		params
	})
}
// 获取车等级列表
export function getLevel() {
	return request({
		url: '/admin/v1/dictionary/cartype',
		method: 'get'
	})
}
// 获取oss
export function getOss(params) {
	return request({
		url: '/admin/v1/oss/get_policy_token',
		method: 'get',
		params
	})
}
/**
 * @description: 获取oss新接口（运力）
 * @param {Number} params.cert_type 文件内容类型
 * @param {String} params.file_ext 文件扩展名
 * @param {String} params.content_type 文件类型
 * @param {Number} params.file_size 文件大小
 * @return {*}
 */
export function getOssDriver(params) {
	return request({
		url: '/admin/dcms/v1/oss/get_cert_policy',
		method: 'get',
		params
	})
}
/**
 * @description: 获取oss新接口（通用）
 * @param {Number} params.cert_type 文件内容类型
 * @param {String} params.file_ext 文件扩展名
 * @param {String} params.content_type 文件类型
 * @param {Number} params.file_size 文件大小
 * @param {String} params.caller 业务来源
 * @return {*}
 */
export function getOssCommon(params) {
	return request({
		url: '/admin/v1/oss/get_cert_policy',
		method: 'get',
		params
	})
}

/**
 * @description: 上传文件设置文件属性（私有、公有）
 * @param {String} data.file_url 文件地址
 * @param {String} data.acl_type 文件属性 1：私有，2：公开读， 0：默认bucket属性
 * @return {*}
 */
export function setOssAcl(data) {
	return request({
		url: '/admin/v1/passenger/oss/set_acl',
		method: 'POST',
		data
	})
}

// OCR获取百度token
export function getOcr() {
	return request({
		url: '/admin/v1/get_baidu_token',
		method: 'get'
	})
}

// OCR获取百度token
export function getUpgradeBusiness(query) {
	return requestNoToast({
		url: '/admin/v1/car/upgrade-business',
		method: 'get',
		params: query
	})
}

// 获取resource免审ocr识别
export function getRegisterOcrSave(params) {
	return request({
		url: '/admin/v1/register/ocr/save',
		method: 'POST',
		data: params
	})
}

// 获取vin识别信息
export function getRegisterOcrVin(params) {
	return request({
		url: '/admin/v1/register/vin/analysis',
		method: 'POST',
		data: params
	})
}
